module.exports = __webpack_public_path__ + "img/croissant.6170c7ad.jpg";